import React, { useState } from "react";
import { Link } from "react-router-dom";
import { RightOutlined } from '@ant-design/icons';
import '../App.css';

export default function Story(props) {

    const SM = props.SM;
    const [ state, setState ] = useState(SM.ONE);

    const next = () => {
        if (!state.fin) {

            if (props.updateState) {
                props.updateState(state.step())
            }
            setState(state.step())
        } 
    }

    

    return (
        <div className='story flex flex-col-reverse ' style={{ backgroundImage: `${state.bgImg}`}} >  

            <div className="absolute top-0 right-0 m-4">
                <Link to={props.complete}>
                    <button className="bg-white hover:bg-teal-900 text-teal-800 font-bold py-4 px-6 rounded-full text-2xl ">Skip Story</button>
                </Link>
                
            </div>
            

            <div className={`basis-1/3 p-8 relative shrink-0 ${state.speechDivColor}`} onClick={next}>

                <div className={`absolute h-16 -top-6 bg-teal-900 rounded-full flex items-center justify-center p-6 ${state.nameAlign} z-10`}>
                    <p className='text-3xl font-bold text-white'>{state.nameText}</p>
                </div>

                <p className={`text-2xl mt-6 z-9 ${state.speechTextColor} ${state.speechFontStyle}`}>{state.speechText}</p>

                {/* { state.fin && 
                <Link to={props.complete} className="absolute bottom-0 right-0 m-8 bg-teal-600 p-2 rounded-lg">
                    <RightOutlined style={{ fontSize: '30px', color:"#ffffff" }} />
                </Link>
                } */}

                {state.fin
                    ? <Link to={props.complete} className="absolute bottom-0 right-0 m-8 bg-teal-600 p-2 rounded-lg">
                        <RightOutlined style={{ fontSize: '30px', color:"#ffffff" }} />
                    </Link>

                    : <div className="absolute bottom-0 right-0 m-6 p-2 ">
                        <RightOutlined style={{ fontSize: '30px', color:`${state.arrowColour}` }} />
                    </div>
                }

            </div>

            {/* <div className="flex flex-row">
                <img src="/characters/customer-1.png" width="200" height="300"/>
                <img src="/characters/customer-2.png" width="200" height="300"/>
            </div> */}

            { state.characters &&
                <div className="flex flex-row justify-evenly ">

                    {  state.characters.map((character, i) => (
                        <div key={i}>
                            {character.active
                                ? 
                                    <img 
                                        src={character.img}
                                        alt="Member who wants to check statement of account" 
                                        width="auto" height="300"
                                        // className="pls"
                                    />
                                : 
                                    <img 
                                        src={character.img}
                                        alt="Member who wants to check statement of account" 
                                        width="auto" height="300"
                                        className="brightness-50" // overlay character
                                    />
                            }
                        </div>
                    ))}

                </div>
            }

            



            {/* <div className='absolute top-0 right-0 m-6'>
                <Button type="primary" >
                    skip
                </Button>
            </div> */}

            {/* { state.fin && 
            <Link to="/task-selection" style={{ alignSelf: "flex-end", marginTop: "auto" }}>
                <Button type="primary" classNameName="button-finish">
                    Finish
                </Button>
            </Link>
            }

            <img classNameName="phoneDisplay" src={ state.img }
                onClick={(e) => {
                    if (!state.fin) {
                        if (props.updateState) {
                            props.updateState(state.step())
                        }
                        setState(state.step())
                    }
                }} 
            /> */}

        </div>
    );
}